/**
 * Sistema de Tema Centralizado para Styled-Components
 * 
 * Este archivo contiene todas las variables de diseño del proyecto
 * que se usarán con styled-components a través del ThemeProvider
 */

export const theme = {
    // Colores principales
    colors: {
        primary: '#007bff',
        secondary: '#6c757d',
        success: '#28a745',
        danger: '#dc3545',
        warning: '#ffc107',
        info: '#17a2b8',
        light: '#f8f9fa',
        dark: '#343a40',
        
        // Colores específicos del proyecto
        main: '#007bff',
        mainText: '#15183C',
        background: '#F4F7FE',
        backgroundPaper: '#ffffff',
        
        // Colores de texto
        text: {
            primary: '#15183C',
            secondary: '#6b6b6b',
            muted: '#6b6b6b',
            inverse: '#ffffff',
        },
        
        // Colores de fondo
        background: {
            default: '#F4F7FE',
            paper: '#ffffff',
            hover: '#f9f9f9',
        },
        
        // Colores de borde
        border: {
            default: '#e5e5e5',
            light: '#f1f1f1',
            dark: '#c7c7c7',
        },
        
        // Colores específicos de componentes
        button: {
            primary: '#007bff',
            danger: '#E31A1A',
            icon: '#F4F7FE',
        },
    },
    
    // Espaciado (spacing)
    spacing: {
        xs: '4px',
        sm: '8px',
        md: '16px',
        lg: '24px',
        xl: '32px',
        xxl: '48px',
        xxxl: '64px',
    },
    
    // Border radius
    borderRadius: {
        sm: '4px',
        md: '8px',
        lg: '12px',
        xl: '16px',
        round: '50%',
        // Mantener compatibilidad con CSS variables
        buttons: '4px', // var(--buttons-border-radius)
    },
    
    // Tipografía
    typography: {
        fontFamily: {
            primary: "'DM Sans', sans-serif",
            secondary: "'Poppins', sans-serif",
            system: "ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Arial",
        },
        fontSize: {
            xs: '12px',
            sm: '14px',
            md: '16px',
            lg: '18px',
            xl: '24px',
            xxl: '34px',
        },
        fontWeight: {
            light: 300,
            normal: 400,
            medium: 500,
            semibold: 600,
            bold: 700,
        },
        lineHeight: {
            tight: 1.2,
            normal: 1.5,
            relaxed: 1.75,
        },
    },
    
    // Breakpoints para media queries
    breakpoints: {
        xs: '0px',
        sm: '576px',
        md: '768px',
        lg: '992px',
        xl: '1200px',
        xxl: '1400px',
    },
    
    // Sombras
    shadows: {
        none: 'none',
        sm: '0 1px 2px rgba(0,0,0,0.05)',
        md: '0 4px 6px rgba(0,0,0,0.1)',
        lg: '0 10px 15px rgba(0,0,0,0.1)',
        xl: '0 20px 25px rgba(0,0,0,0.15)',
        inner: 'inset 0 2px 4px rgba(0,0,0,0.06)',
    },
    
    // Transiciones
    transitions: {
        fast: '0.15s ease',
        normal: '0.2s ease',
        slow: '0.3s ease',
        // Transiciones específicas
        margin: 'margin 0.25s ease-out',
    },
    
    // Z-index layers
    zIndex: {
        base: 1,
        dropdown: 1000,
        sticky: 1020,
        fixed: 1030,
        modalBackdrop: 1040,
        modal: 1050,
        popover: 1060,
        tooltip: 1070,
        sidebar: 999999, // Para sidebar móvil
    },
    
    // Alturas específicas
    heights: {
        button: {
            default: '46px',
            icon: '37px',
            small: '32px',
        },
        input: {
            default: '36px',
            small: '32px',
        },
    },
    
    // Anchos mínimos
    minWidths: {
        button: {
            default: '200px',
            text: '100px',
        },
    },
};

export default theme;

